module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (this.$route.query.cc) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPage),
      expression: "showPage"
    }],
    staticClass: "content",
    staticStyle: {
      "background-color": "#fafafa"
    }
  }, [_c('div', {
    staticClass: "mod"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "add-btn research-background-color",
    staticStyle: {
      "padding-top": "10px"
    },
    on: {
      "click": _vm.go
    }
  }, [_vm._v("开始签署合同")])])]), _vm._v(" "), _c('footer-placeholder')], 1)])])]) : _c('div', [(_vm.isSpecialPromotion) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.baseurl + 'c276.png'
    },
    on: {
      "click": _vm.goToSpecialPromotion
    }
  })])]) : (_vm.$route.query.isadvertising) ? _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', [(_vm.openLink()) ? _c('a', {
    attrs: {
      "href": "https://genechem.jinshuju.net/f/S85ziR",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.baseurl + _vm.$route.query.detailImageUrl
    }
  })]) : (_vm.openLink2()) ? _c('a', {
    attrs: {
      "href": "https://jinshuju.net/f/ZV4SUF",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.baseurl + _vm.$route.query.detailImageUrl
    }
  })]) : (_vm.openLink3()) ? _c('a', {
    attrs: {
      "href": "https://jinshuju.net/f/nrxuBV",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.baseurl + _vm.$route.query.detailImageUrl
    }
  })]) : _c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.baseurl + _vm.$route.query.detailImageUrl
    },
    on: {
      "click": function($event) {
        return _vm.goToActivity()
      }
    }
  })])]) : _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "white"
    }
  }, [(!_vm.isWapp) ? _c('div', {
    staticStyle: {
      "margin-bottom": "2.5rem"
    }
  }, [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n          ")])])]) : _vm._e(), _vm._v(" "), _c('div', [(_vm.$route.query.detailImageUrl && _vm.openLink()) ? _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://genechem.jinshuju.net/f/S85ziR",
      "target": "_blank"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.baseurl + _vm.$route.query.detailImageUrl
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.$route.query.detailImageUrl && !_vm.openLink()) ? _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.checkForCouponActivity()
      }
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "src": _vm.baseurl + _vm.$route.query.detailImageUrl
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', [_vm._l((_vm.coupons), function(tabs) {
    return (_vm.coupons && !_vm.$route.query.activityId) ? _c('div', {
      staticStyle: {
        "margin-bottom": "0.6rem"
      }
    }, [_c('div', [_c('img', {
      staticStyle: {
        "margin-left": "0.5rem",
        "height": "100%",
        "width": "100%"
      },
      attrs: {
        "src": _vm.baseurl + tabs.imageUrl
      },
      on: {
        "click": function($event) {
          return _vm.getcoupon(tabs)
        }
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.bcoupons), function(ctabs) {
    return (_vm.bcoupons && !_vm.$route.query.activityId) ? _c('div', {
      staticStyle: {
        "margin-bottom": "0.6rem"
      }
    }, [_c('table', {
      attrs: {
        "border": "0",
        "cellpadding": "0",
        "cellspacing": "0",
        "width": "100%"
      }
    }, [_c('tr', [_c('td', [_c('img', {
      staticStyle: {
        "height": "100%",
        "clear": "both",
        "display": "block",
        "margin": "auto"
      },
      attrs: {
        "src": _vm.baseurl + ctabs.imageUrl
      },
      on: {
        "click": function($event) {
          return _vm.getcoupon(ctabs)
        }
      }
    })])])])]) : _vm._e()
  }), _vm._v(" "), _c('div'), _vm._v(" "), _vm._m(2)], 2), _vm._v(" "), _c('newMerchandiseListA', {
    attrs: {
      "merchList": _vm.merchandise,
      "description": _vm.$route.query.des,
      "channel": _vm.$route.params.channel
    }
  }), _vm._v(" "), (_vm.merchandise.length > 10) ? _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.loadmore
    }
  }, [_vm._v("更多...")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "id": "over"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "submain"
  }, [_c('img', {
    staticClass: "icon_12",
    attrs: {
      "src": "/static/img/authentication4.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "pic",
    attrs: {
      "src": "/static/img/authentication11.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": "/static/img/authentication9.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "icon_13",
    attrs: {
      "src": "/static/img/authentication4.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "summary"
  }, [_vm._v("在支付宝中使用E签宝小程序，根据提示完成人脸识别，并签署合同")]), _vm._v(" "), _c('span', {
    staticClass: "desc_1"
  }), _vm._v(" "), _c('img', {
    staticClass: "img",
    attrs: {
      "src": "/static/img/authentication10.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "word_1"
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }), _vm._v(" "), _c('span', {
    staticClass: "info_3"
  }), _vm._v(" "), _c('span', {
    staticClass: "word_2"
  }), _vm._v(" "), _c('span', {
    staticClass: "info_4"
  }, [_vm._v("打开短信中的链接，点击"), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("「快捷签署」")]), _vm._v("，跳转支付宝"), _c('span', {
    staticStyle: {
      "color": "#FE654D"
    }
  }, [_vm._v("（未开通支付宝请咨询客服进行人工认证）")])]), _vm._v(" "), _c('span', {
    staticClass: "info_5"
  }, [_c('span', {
    staticStyle: {
      "color": "#5878fa"
    }
  }, [_vm._v("点击发起签署")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "400"
    }
  }, [_vm._v("，认证链接会以短信形式发送到您的手机上")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "absolute",
      "top": "30px",
      "margin-left": "70px"
    }
  }, [_c('span', {
    staticStyle: {
      "padding-right": "12px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "27px",
      "height": "2px",
      "margin-bottom": "3px",
      "color": "#D2D2D6"
    },
    attrs: {
      "src": "/static/img/authentication1.png"
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "line-height": "21px",
      "white-space": "nowrap",
      "color": "#424242",
      "font-size": "21px",
      "font-weight": "500"
    }
  }, [_vm._v("\n            合同签署流程\n            ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-left": "12px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "27px",
      "height": "2px",
      "margin-bottom": "3px",
      "color": "#D2D2D6"
    },
    attrs: {
      "src": "/static/img/authentication1.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('img', {
    staticClass: "icon_14",
    staticStyle: {
      "background": "#d2d2d6",
      "width": "15px",
      "height": "1px"
    },
    attrs: {
      "src": "/static/img/authentication1.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info_7"
  }, [_vm._v("我是有底线的")]), _vm._v(" "), _c('img', {
    staticClass: "icon_15",
    staticStyle: {
      "background": "#d2d2d6",
      "width": "15px",
      "height": "1px"
    },
    attrs: {
      "src": "/static/img/authentication1.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "search-input",
    staticStyle: {
      "margin-left": "0.5rem",
      "margin-right": "0.5rem",
      "margin-top": "0.5rem"
    }
  }, [_c('label', {
    staticClass: "icon icon-search",
    attrs: {
      "for": "search"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "open-popup open-goods",
    attrs: {
      "type": "search",
      "id": "search",
      "data-popup": ".popup-goods",
      "placeholder": "输入商品...",
      "readonly": "",
      "unselectable": "on"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-659e6253","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Promotion/Promotions.vue
// module id = 1664
// module chunks = 8